<template>

    <swiper
        :id="id"
        :modules="modules"
        :slides-per-view="1.2"
        :space-between="8"
        :speed="700"
        :breakpoints="{
         '768': {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true
          },
        }"
        :pagination="{
            type: 'bullets',
            clickable: 'true',
        }"
        :autoplay="{
            delay: 5000,
            disableOnInteraction: true,
        }"
        :loop="false"
        :enabled="true"
    >
        <slot />
    </swiper>
    <div class="button-wrapper" v-if="show_arrows">
        <div  class="swiper-navigation swiper-prev" @click="navigate(id,'prev')"><svg width="18" height="54" viewBox="0 0 18 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.78125 26.9958L16.6308 0.806641L17.2289 1.8655L2.02016 26.9958L17.2289 52.1261L16.6308 53.1143L0.78125 26.9958Z" fill="black"/>
        </svg></div>
        <div  class="swiper-navigation swiper-next" @click="navigate(id,'next')"><svg width="17" height="54" viewBox="0 0 17 54" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4473 26.9958L0.597733 0.806641L-0.000362396 1.8655L15.2084 26.9958L-0.000362396 52.1261L0.597733 53.1143L16.4473 26.9958Z" fill="black"/>
        </svg></div>
    </div>

</template>

<script>
import { computed, onMounted } from "vue";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { windowOrientation } from "@/utils";


export default {
    name: "stage-slider",
    props: {
        swiperid: String,
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    setup(props) {

        const id = 'swiper-'+props.swiperid
        const show_arrows = computed(() => {
            return windowOrientation.value.width >  1540;
        });
        onMounted(() => {
            const swiper = document.getElementById(id).swiper;
            const wrapper = document.querySelector('#'+id+' .swiper-wrapper');
            swiper.on('slideChange', function() {

                if(swiper.isEnd){
                    wrapper.classList.add('is-end');
                }
                else{
                    wrapper.classList.remove('is-end');
                }

            })
        });
        return {
            id,
            show_arrows,
            modules: [Autoplay, Pagination, Navigation],
        };
    },
    methods: {
        navigate(id,direction) {
            const swiper = document.getElementById(id).swiper;
            if( direction === 'next'){
                swiper.slideNext();
            }
            if( direction === 'prev'){
                swiper.slidePrev();
            }
        }
    }
};
</script>

<style lang="scss">
@use "@/scss/design-library/placeholders";
@use "@/scss/design-library/animations";
@use "@/scss/design-library/grid";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/functions/calculate";

.stageslider{

    --mdc-layout-grid-margin-mobile: 0;
    @extend %teaser;

    .swiper-wrapper {
        transition: all 1s;
        margin-left: 8vw;
        @extend .animate__image--hover-grow;
        @include grid.media-query_up_(tablet_portrait) {
            margin-left: 0;
        }
        &.is-end {
            margin-left: -8vw;
            @include grid.media-query_up_(tablet_portrait) {
                margin-left: 0;
            }
        }
    }

    .teaser-description {
        margin-bottom:#{calculate.rem(16)};
    }

    .teaser-image {
        @extend .animate__image--wrap;
        img {
            @extend .animate__image--img;
        }
    }

    .teaser-wrapper {
        .teaser-content {
            padding-top: #{calculate.rem(23)};
            padding-inline: calculate.rem(37);
            @include grid.media-query_up_(tablet_portrait) {
                padding-top: 0;
                padding-inline: calculate.rem(50);
            }
            @include grid.media-query_up_(tablet_landscape) {
                padding-inline: calculate.rem(105);
            }
        }
    }
    .button-wrapper {
        position: absolute;
        display: flex;
        justify-content: space-between;
        align-items: center;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        padding: inherit;
        .swiper-navigation {
            cursor: pointer;
            &.swiper-prev{
                margin-left: -40px
            }
            &.swiper-next{
                margin-right: -40px
            }
        }
    }
}

</style>
